import React, { Component } from 'react';
import { trackDisplay, trackAccept, trackClose } from './analytics';
import { trace } from './log';

export const withTracking = (BannerComponent, campaignName, doNotTrack) => {
  class BannerComponentWithTracking extends Component {
    state = {
      accepted: false
    };

    handleDisplay = () => {
      if (doNotTrack) {
        return trace('tracking disabled, otherwise would fire: DISPLAY');
      }
      trackDisplay(campaignName);
    }

    handleAccept = (payload) => {
      if (doNotTrack) {
        return trace(`tracking disabled, otherwise would fire: ACCEPT, with payload: ${payload}`);
      }
      this.setState({ accepted: true });
      trackAccept(campaignName, payload);
    }

    handleClose = () => {
      if (doNotTrack) {
        return trace('tracking disabled, otherwise would fire: CLOSE');
      }
      trackClose(campaignName);
    }

    componentDidMount () {
      this.handleDisplay();
    }

    componentWillUnmount () {
      if (!doNotTrack && !this.state.accepted) {
        // track ignore
      }
    }

    render () {
      return (
        <BannerComponent
          handleAccept={this.handleAccept}
          handleClose={this.handleClose}
          // handleDisplay={this.handleDisplay}
          {...this.props}
        />
      );
    }
  }

  return BannerComponentWithTracking;
};
